/**
 * QuickStats Component
 * 
 * Displays key rotation totals in a horizontal card layout
 */

import React from 'react';

const QuickStats = ({ totals, dutyPeriodCount }) => {
  // Convert minutes to HH:MM format
  const formatMinutes = (minutes) => {
    if (!minutes) return '00:00';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
  };
  
  // Convert minutes to decimal hours for display
  const toHours = (minutes) => {
    if (!minutes) return '0.0';
    return (minutes / 60).toFixed(1);
  };
  
  const stats = [
    {
      label: 'Total Duty Time',
      value: formatMinutes(totals?.total_duty_minutes),
      subtitle: `${toHours(totals?.total_duty_minutes)} hours`,
      emoji: '⏱️',
      color: 'blue'
    },
    {
      label: 'Scheduled Block',
      value: formatMinutes(totals?.total_sched_block_minutes),
      subtitle: `${toHours(totals?.total_sched_block_minutes)} hours`,
      emoji: '✈️',
      color: 'green'
    },
    {
      label: 'Actual Block',
      value: formatMinutes(totals?.total_actual_block_minutes),
      subtitle: `${toHours(totals?.total_actual_block_minutes)} hours`,
      emoji: '✈️',
      color: 'purple'
    },
    {
      label: 'Deadhead',
      value: formatMinutes(totals?.total_deadhead_minutes),
      subtitle: `${toHours(totals?.total_deadhead_minutes)} hours`,
      emoji: '✈️',
      color: 'orange'
    },
    {
      label: 'Duty Periods',
      value: dutyPeriodCount || 0,
      subtitle: dutyPeriodCount === 1 ? 'period' : 'periods',
      emoji: '📅',
      color: 'indigo'
    }
  ];
  
  const colorClasses = {
    blue: 'bg-blue-50 border-blue-200 text-blue-900',
    green: 'bg-green-50 border-green-200 text-green-900',
    purple: 'bg-purple-50 border-purple-200 text-purple-900',
    orange: 'bg-orange-50 border-orange-200 text-orange-900',
    indigo: 'bg-indigo-50 border-indigo-200 text-indigo-900'
  };
  
  return (
    <div className="bg-gray-50 border-y border-gray-200 py-4">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-5 gap-4">
          {stats.map((stat, idx) => {
            return (
              <div
                key={idx}
                className={`border-2 rounded-lg p-4 ${colorClasses[stat.color]}`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-3xl flex-shrink-0">{stat.emoji}</span>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-medium opacity-75 uppercase tracking-wide">
                      {stat.label}
                    </p>
                    <p className="text-2xl font-bold mt-1">
                      {stat.value}
                    </p>
                    <p className="text-xs opacity-75 mt-1">
                      {stat.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default QuickStats;
